<template lang="html">
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-12 text-center px-0">
        <div class="row">
          <div class="col-12">
            <div class="float-left back-btn driver-colour font-weight-bold" @click="$_navigationMixin_navigateBack()">
              <i class="fas fa-chevron-circle-left"></i>
              <span> Back</span>
            </div>
          </div>
          <div class="col-12 col-md-8 col-lg-6 m-auto pb-2 png-wrap">
            <ul class="nav nav-fill row">
              <template v-for="item in items_navigation">
                <li 
                  :class="[
                    'nav-item font-weight-bold nav-breadcrumbs', 
                    'nav-item-' + item.name.toLowerCase(),
                    item.class, 
                    item.link_router == $route.name ? 'active' : '',
                    $_navigationMixin_linkIsDisabled(item) ? 'disabled' : '',
                    $_navigationMixin_itemSelected(item) ? 'selected' :''
                  ]">
                  <router-link 
                    class="nav-link" 
                    :to="{ name: item.link_router, params: {} }">
                    <i :class="item.faIconClass">&nbsp;</i>{{ item.name }}
                  </router-link>
                </li>
                <li 
                  v-show="item.name != 'Complete'"> 
                  <p class="pag-gap d-none d-sm-none d-md-block my-1">----------</p>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-12 px-0 pt-1">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationMixin from '../inc/NavigationMixin.vue';

export default {
  name: 'JoinTeam',

  mixins: [ NavigationMixin ],

  data(){
    return{
      items_navigation:[
        {name: "Select Team", faIconClass: "fas fa-users", link_router: "select_team", class: "gf-ft" },
        {name: "Complete", faIconClass: "far fa-check-circle", link_router: "complete_jointeam", class: "gf-ft" }
      ]
    }
  }
}
</script>

<style lang="css">

</style>
